const Q = require('q');
const ExceptionService = require('exceptions/exception-service.js');

const filename = 'q-library-config.js';

/**
 * This configures the Q libray and attach an event
 * on all uncaught promises. We then decide wether or not we
 * need to send the error to the Exception service base on the error type.
 * If it's a real Error instance (TypeError, ReferenceError), then we log it.
 * If it's just a unhandled promise, we don't.
 */
const QConfig = (function(root, doc, undefined) {

    // https://github.com/kriskowal/q#long-stack-traces
    Q.longStackSupport = true;

    Q.onerror = (error = {}) => {
        const isError = error instanceof Error;
        if(isError){
            const type = error ? error.name : 'Unknown type';
            ExceptionService.handle('error', {
                filename: filename,
                message: `A "${type}" error happened into a promise chain.`,
                data: error
            });
        }
    };

})(window, document);
